import Vue from 'vue'
import Vuex from 'vuex'
import { Howl, Howler } from 'howler'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    numScenes: 6,
    currentScene: 1,
    beginButton: true,
    verseA: '',
    verseB: '',
    muted: false,
    trackTime: 0,
    trackInterval: null,
    audioScene1: new Howl({
      src: ['audio/scene-1.mp3'],
      html5: true
    }),
    audioScene2: new Howl({
      src: ['audio/scene-2.mp3'],
      html5: true
    }),
    audioScene3: new Howl({
      src: ['audio/scene-3.mp3'],
      html5: true
    }),
    audioScene4: new Howl({
      src: ['audio/scene-4.mp3'],
      html5: true
    }),
    audioScene5: new Howl({
      src: ['audio/scene-5.mp3'],
      html5: true
    }),
    audioScene6: new Howl({
      src: ['audio/scene-6.mp3'],
      html5: true
    }),
    isScreenOrientationWarningActive: false
  },
  mutations: {
    SET_CURRENT_SCENE (state, payload) {
      state.currentScene = payload
    },
    PREVIOUS_SCENE (state) {
      state.currentScene--
    },
    NEXT_SCENE (state) {
      state.currentScene++
    },
    SHOW_BEGIN_BUTTON (state) {
      state.beginButton = true
    },
    HIDE_BEGIN_BUTTON (state) {
      state.beginButton = false
    },
    MUTE (state) {
      state.muted = true
    },
    UNMUTE (state) {
      state.muted = false
    },
    SET_VERSE_A (state, payload) {
      state.verseA = payload
    },
    SET_VERSE_B (state, payload) {
      state.verseB = payload
    },
    RESET_TRACK_TIME (state) {
      state.trackTime = 0
    },
    RESET_TRACK_INTERVAL (state) {
      clearInterval(state.trackInterval)
      state.trackInterval = setInterval(() => {
        state.trackTime += 0.5
      }, 500)
    },
    CLEAR_TRACK_INTERVAL (state) {
      clearInterval(state.trackInterval)
    },
    SHOW_SCREEN_ORIENTATION_WARNING (state) {
      state.isScreenOrientationWarningActive = true
    },
    HIDE_SCREEN_ORIENTATION_WARNING (state) {
      state.isScreenOrientationWarningActive = false
    }
  },
  actions: {
    begin ({ commit, dispatch }) {
      commit('HIDE_BEGIN_BUTTON')
      dispatch('playSceneAudio')
    },
    previousScene ({ state, commit, dispatch }) {
      if (state.currentScene > 1) {
        commit('PREVIOUS_SCENE')
      }
      dispatch('playSceneAudio')
    },
    nextScene ({ state, commit, dispatch }) {
      if (state.currentScene < state.numScenes) {
        commit('NEXT_SCENE')
      } else {
        if (window.history.length > 1) {
          window.history.go(-1)
        } else {
          commit('SET_CURRENT_SCENE', 1)
        }
      }
      dispatch('playSceneAudio')
    },
    toggleMute ({ state, commit }) {
      if (state.muted) {
        Howler.mute(false)
        commit('UNMUTE')
      } else {
        Howler.mute(true)
        commit('MUTE')
      }
    },
    stopAllAudio ({ state, commit }) {
      state.audioScene1.stop()
      state.audioScene2.stop()
      state.audioScene3.stop()
      state.audioScene4.stop()
      state.audioScene5.stop()
      state.audioScene6.stop()
      commit('CLEAR_TRACK_INTERVAL')
      commit('RESET_TRACK_TIME')
    },
    playSceneAudio ({ state, commit, dispatch }) {
      dispatch('stopAllAudio')
      switch (state.currentScene) {
        case 1:
          state.audioScene1.play()
          commit('RESET_TRACK_INTERVAL')
          commit('RESET_TRACK_TIME')
          break
        case 2:
          state.audioScene2.play()
          commit('RESET_TRACK_INTERVAL')
          commit('RESET_TRACK_TIME')
          break
        case 3:
          state.audioScene3.play()
          commit('RESET_TRACK_INTERVAL')
          commit('RESET_TRACK_TIME')
          break
        case 4:
          state.audioScene4.play()
          commit('RESET_TRACK_INTERVAL')
          commit('RESET_TRACK_TIME')
          break
        case 5:
          state.audioScene5.play()
          commit('RESET_TRACK_INTERVAL')
          commit('RESET_TRACK_TIME')
          break
        default:
          break
      }
    },
    playBlues ({ state, commit }) {
      state.audioScene6.play()
      commit('RESET_TRACK_INTERVAL')
      commit('RESET_TRACK_TIME')
    },
    stopBlues ({ state, commit }) {
      state.audioScene6.stop()
      commit('CLEAR_TRACK_INTERVAL')
      commit('RESET_TRACK_TIME')
    },
    detectScreenOrientation ({ commit }) {
      if (window.innerWidth < window.innerHeight) {
        commit('SHOW_SCREEN_ORIENTATION_WARNING')
      } else {
        commit('HIDE_SCREEN_ORIENTATION_WARNING')
      }
    }
  }
})

export default store
